<div id="spinner">
  <span id="spinner-icon" class="fa fa-spinner fa-lg"></span> {{text}}
</div>